<template>
  <div class="skeleton-style-guide-container">
    <div
      v-for="(_, i) in Array(1)"
      :key="i"
    >
      <v-skeleton-loader
        v-if="showGroupHeader"
        class="pt-6 pb-2 group-header-skeleton"
        type="heading"
        width="175"
      />
      <div
        class="skeleton-style-group"
        :style="{ height: `${Math.floor(250 * numberToLoad / 2) + (6 * numberToLoad)}px` }"
      >
        <v-card
          v-for="(__, j) in Array(numberToLoad)"
          :key="j"
          class="skeleton-style-form pa-6 shadow"
        >
          <v-card-title class="ma-0 pa-0 skeleton-style-title">
            <v-skeleton-loader
              type="heading"
              width="175"
            />
            <DpplSkeletonLoader>
              <DpplToggleButton
                v-if="showToggle"
                class="mt-0 pt-0"
                :disabled="true"
                hide-details
              />
            </DpplSkeletonLoader>
          </v-card-title>

          <v-card-text class="skeleton-style-content pa-0">
            <v-skeleton-loader
              type="text"
              width="275"
            />
            <div class="skeleton-style-rules">
              <v-skeleton-loader
                type="list-item-three-line"
              />
              <div />
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>

import DpplToggleButton from '@/components/datapeople/DpplToggleButton.vue';
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';

export default {
  name: 'SettingsCardSkeletonLoader',
  components: {
    DpplToggleButton,
    DpplSkeletonLoader,
  },
  props: {
    numberToLoad: {
      type: Number,
      default: 2,
    },
    showToggle: {
      type: Boolean,
      default: false,
    },
    showGroupHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
  .skeleton-style-guide-container {
    width: 100%;

    .group-header-skeleton {
      background: transparent;
    }
  }
  .skeleton-style-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .skeleton-style-form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(50% - 6px);
    height: 250px;
    background-color: @white;
    border-radius: 10px;
  }
  .skeleton-style-title {
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .skeleton {
      overflow: visible;
    }
  }
  .skeleton-style-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .skeleton-style-rules {
    margin-top: 8px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    padding: 0;
  }
  :deep(.dppl-list-item.v-list-item:hover) {
    box-shadow: none;
    cursor: progress;
  }
  .right-side-loader, .left-side-loader :deep(.v-skeleton-loader__list-item) {
    height: 100%;
  }
  .left-side-loader :deep(.v-skeleton-loader__list-item) {
    height: 100%;
  }
  :deep(.v-skeleton-loader__heading) {
    width: 100%;
    height: 20px;
    margin-bottom: 8px;
  }
  :deep(.v-skeleton-loader__text) {
    width: 100%;
    height: 16px;
    border-radius: 10px;
  }
  :deep(.v-skeleton-loader__list-item-three-line) {
    padding: 0;
  }
</style>
